import { useState } from 'react';

import useStudent from 'store/student/useStudent';
import { setCookie } from 'utils/cookie';
import useUser from 'store/user/useUser';

import {
  Dialog,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Stack,
  Grid,
  useTheme,
} from '@mui/material';

import { ReactComponent as Number01 } from 'assets/icon-number-01.svg';
import { ReactComponent as Number02 } from 'assets/icon-number-02.svg';
import { ReactComponent as Number03 } from 'assets/icon-number-03.svg';
import { ReactComponent as Number04 } from 'assets/icon-number-04.svg';
import { ReactComponent as Number05 } from 'assets/icon-number-05.svg';

export interface SimpleDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setShow: (show: boolean) => void;
}

function Introduction(props: SimpleDialogProps) {
  const { palette } = useTheme();
  const { open, setOpen, setShow } = props;
  // const { student_name } = useStudent();

  const {
    student_name,
    student_uuid,
    student_grade,
    college_ci,
    college_name,
  } = useUser();

  const contents = [
    {
      title: '平台',
      desc1: 'Smart ENR 是為護理學生和新護士設計的電子護理記錄系統。',
      desc2: '',
      desc3: '',
    },
    {
      title: '背景',
      desc1: '美國約 97% 的醫院使用電子健康記錄 (EHR) 系統，護士將高達',
      desc2: '35% 的工作時間用於護理文檔。',
      desc3: '',
    },
    {
      title: '我們的解決方案',
      desc1: '我們開發了 Smart ENR，通過使用 EHR 系統練習來幫助護理學',
      desc2: '生和新護士克服這些挑戰。',
      desc3: '',
    },
    {
      title: '卓越的可用性',
      desc1: 'Smart ENR 是基於雲的，允許您隨時隨地在任何設備上訪問——',
      desc2: 'PC、筆記本電腦、平板電腦或智能手機——無需安裝。',
      desc3: '',
    },
    {
      title: '當前問題',
      desc1: '大多數新護士在護理記錄方面面臨挑戰。',
      desc2: '',
      desc3: '',
    },
  ];

  const icons = [
    <Number01 fill={palette.primary.main} />,
    <Number04 fill={palette.primary.main} />,
    <Number02 fill={palette.primary.main} />,
    <Number05 fill={palette.primary.main} />,
    <Number03 fill={palette.primary.main} />,
  ];

  /* 다시 보지 않기 체크박스 관련 */
  const [check, setCheck] = useState(false);
  /*************************/

  return (
    <Dialog
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '75%',
            padding: '50px 100px',
            backgroundColor: palette.mode === 'dark' ? 'grey' : '',
          },
        },
      }}
      onClose={() => setOpen(false)}
      open={open}
    >
      <Stack direction="row">
        <Typography
          sx={{ fontWeight: '700', fontSize: '64px', lineHeight: '80px' }}
        >
          歡迎,
        </Typography>
        <Typography
          sx={{
            color: `${palette.primary.main}`,
            fontWeight: '700',
            fontSize: '64px',
            lineHeight: '80px',
          }}
        >
          {student_name}
        </Typography>
      </Stack>
      <Typography
        sx={{ fontWeight: '700', fontSize: '64px', lineHeight: '80px' }}
      >
        這是 Smart ENR :)
      </Typography>
      <Typography
        sx={{
          color: `${palette.primary.main}`,
          fontWeight: '700',
          fontSize: '30px',
          lineHeight: '50px',
        }}
      >
        我們來練習護理記錄吧？
      </Typography>
      {/* <Button
        sx={{
          width: '187px',
          height: '48px',
          color: 'white',
          backgroundColor: `${palette.primary.main}`,
          marginTop: '15px',
          whiteSpace: 'nowrap',
        }}
        variant="contained"
        onClick={() => {
          setShow(true);
          setOpen(false);
        }}
      >
        Tap to keep watching
      </Button> */}
      <Grid
        container
        columnSpacing={10}
        rowSpacing={5}
        marginTop="62px"
        marginBottom="45px"
      >
        {contents.map(({ title, desc1, desc2, desc3 }, idx) => (
          <Grid item xs={6}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              marginBottom="20px"
            >
              {icons[idx]}
              <Typography
                sx={{
                  color: `${palette.primary.main}`,
                  fontWeight: '700',
                  fontSize: '40px',
                  lineHeight: '50px',
                }}
              >
                {title}
              </Typography>
            </Stack>
            <Typography sx={{ whiteSpace: 'nowrap' }}>
              {desc1}
              <br />
              {desc2}
              <br />
              {desc3}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Stack direction="row" spacing={2}>
        <Button
          sx={{
            width: '187px',
            height: '48px',
            color: `${palette.primary.main}`,
          }}
          variant="outlined"
          onClick={() => {
            if (check) setCookie('no_intro', 'true', 30);
            setShow(false);
            setOpen(false);
          }}
        >
          点击关闭
        </Button>
        <FormControlLabel
          control={
            <Checkbox
              value={check}
              onChange={e => setCheck(e.target.checked)}
            />
          }
          label="不要再次显示此消息"
        />
      </Stack>
    </Dialog>
  );
}

export default Introduction;
